import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CategoryFormComponent } from './category-form.component';
import { SearchableDropdownModule } from '../../../../../global/components/searchable-dropdown/searchable-dropdown.module';
import { SharedModule } from '../../../shared/shared.module';
import { GlobalModule } from '../../../../../global/global.module';
import { SelectListV2Module } from '../../../../../global/components/forms/select-list-v2/select-list-v2.module';

@NgModule({
    declarations: [CategoryFormComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        SearchableDropdownModule,
        SharedModule,
        GlobalModule,
        SelectListV2Module,
    ],
    exports: [CategoryFormComponent],
})
export class CategoryFormModule {}
